
<div class="folderInDetail" *ngIf="folderetails != '' && folderetails != undefined">
  <div class="iconUser" *ngIf="typeId == 1">
    <mat-icon *ngIf="isShared != 'true'">folder</mat-icon>
    <mat-icon *ngIf="isShared == 'true'">folder_shared</mat-icon>
    <div class="nmFile">
      <h4>{{ folderetails.formFolderName }}</h4>
      <span class="filecount">{{ folderetails.itemCount }} Items</span>
    </div>
  </div>

  <div class="iconUser" *ngIf="typeId == 2">
    <mat-icon>description</mat-icon>
    <div class="nmFile">
      <h4>{{ folderetails.formName }}</h4>
    </div>
  </div>

  <div class="" *ngIf="typeId == 1 && folderetails.permissionType == 1">
    <button mat-icon-button [matMenuTriggerFor]="mainfolder">
      <mat-icon>more_vertical</mat-icon>
    </button>
    <mat-menu #mainfolder="matMenu" xPosition="before">
      <!-- <button mat-menu-item [routerLink]="'/esignature/first'">
        <mat-icon>picture_as_pdf</mat-icon> Create Pdf Form
      </button>
      <button mat-menu-item [routerLink]="'/esignature/htmlcanvas'">
        <mat-icon>code</mat-icon> Create Html Form
      </button> -->
      <button mat-menu-item (click)="RenameFolders(folderetails)">
        <mat-icon>format_size</mat-icon> Rename
      </button>
      <button mat-menu-item><mat-icon>low_priority</mat-icon> Move to</button>
      <button mat-menu-item (click)="DeleteFolders(folderetails)">
        <mat-icon>delete_outline</mat-icon> Delete
      </button>
    </mat-menu>
  </div>
  <ng-container *ngIf="folderetails.permissionType == 1">
  <div class="" *ngIf="typeId == 2">
    <button mat-icon-button [matMenuTriggerFor]="mainfolder">
      <mat-icon>more_vertical</mat-icon>
    </button>
    <mat-menu #mainfolder="matMenu" xPosition="before">
      <button mat-menu-item><mat-icon>link</mat-icon> URL</button>
      <button mat-menu-item><mat-icon>create</mat-icon> Sign</button>
      <button mat-menu-item [routerLink]="'/esignature/canvas'">
        <mat-icon>assignment</mat-icon> Fill
      </button>
      <button mat-menu-item [routerLink]="'/esignature/canvas'">
        <mat-icon>format_shapes </mat-icon> Edit
      </button>
      <button mat-menu-item (click)="fileAccess(access)">
        <mat-icon>supervised_user_circle</mat-icon> File Access
      </button>
      <button mat-menu-item [routerLink]="'/esignature/report'">
        <mat-icon>donut_large</mat-icon>Show Report
      </button>
      <button mat-menu-item (click)="RenameFolders(folderetails)">
        <mat-icon>format_size</mat-icon> Rename
      </button>
      <button mat-menu-item><mat-icon>low_priority</mat-icon> Move to</button>
      <button mat-menu-item (click)="DeleteFolders(folderetails)">
        <mat-icon>delete_outline</mat-icon> Delete
      </button>
    </mat-menu>
  </div>
</ng-container>
  <ng-container *ngIf="folderetails.permissionType == 0">
    <div class="" *ngIf="typeId == 2">
      <button mat-icon-button [matMenuTriggerFor]="mainfolder">
        <mat-icon>more_vertical</mat-icon>
      </button>
      <mat-menu #mainfolder="matMenu" xPosition="before">
        <button mat-menu-item><mat-icon>link</mat-icon> URL</button>
        <button mat-menu-item><mat-icon>create</mat-icon> Sign</button>
        <button mat-menu-item [routerLink]="'/esignature/canvas'">
          <mat-icon>assignment</mat-icon> Fill
        </button>
      </mat-menu>
    </div>
  </ng-container>
</div>

<div class="notselected" *ngIf="folderetails == '' || folderetails == undefined">
<mat-icon>speaker_notes_off</mat-icon>
<p>Select a file or folder to view its details</p>
</div>

<div class="docDetail detailtabs" *ngIf="folderetails != '' && folderetails != undefined">
  <mat-tab-group animationDuration="0ms" (selectedTabChange)="onTabClick($event)">
    <mat-tab label="Detail">

      <div  class="folderInDetail">
        <div class="metadetails">
          <div class="fileTypecount" *ngIf="isSharedWithMeForm != 'true'">
            <ng-container *ngIf="SharedContactRoleCount != 0">
              <p>Shared with</p>
              <div class="userlist">
                
                <div
                  class="userCount"
                  (click)="showSharedContactRoleList()"
                  matTooltipClass="tooltip">
                  {{ SharedContactRoleCount }}
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="SharedContactRoleCount == 0">
              <div class="userlist">
                <p>Private</p>
              </div>
            </ng-container>            
            
          </div>

          <div class="info meta">
            <p *ngIf="typeId == 1"><span>Type</span>Folder</p>
            <p *ngIf="typeId == 2"><span>Type</span>Form</p>
            <p>
              <span>Created By</span>{{ folderetails.createdByFirstName }}
              {{ folderetails.createdByLastName }}
            </p>
            <p>
              <span>Created On</span>
              {{ folderetails.createdOn+'Z' | date: "MM/dd/yyyy h:mm a" }}
            </p>
            <p *ngIf="folderetails.updatedBy != '' && folderetails.updatedBy !='00000000-0000-0000-0000-000000000000'">
              <span>Modified By</span>{{ folderetails.updatedByFirstName }}
              {{ folderetails.updatedByLastName }}
            </p>
            <p *ngIf="folderetails.updatedOn != '' && folderetails.updatedOn != '0001-01-01T00:00:00'">
              <span>Modified On</span>
              {{ folderetails.updatedOn+'Z' | date: "MM/dd/yyyy h:mm a" }}
            </p>
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Notes" >
      <div class="touches_holder">
        <div class="addtouch">
          <button mat-stroked-button color="primary" (click)="addTouch()">
            <mat-icon>add</mat-icon> Add Note
          </button>
        </div>

        <div class="touches" *ngFor="let touch of allFormFolderTouchesList">
          <h4 class="note" *ngIf="touch.touchTypeName == 'Note'">
            <mat-icon>event_note</mat-icon> {{ touch.createdByFirstName }}
            {{ touch.createdByLastName
            }}<span> added this {{ touch.touchTypeName }}</span>
          </h4>

          <h4 class="call" *ngIf="touch.touchTypeName == 'Phone Call'">
            <mat-icon>local_phone</mat-icon> {{ touch.createdByFirstName }}
            {{ touch.createdByLastName
            }}<span> added this {{ touch.touchTypeName }}</span>
          </h4>

          <h4 class="email" *ngIf="touch.touchTypeName == 'Email'">
            <mat-icon>mail</mat-icon> {{ touch.createdByFirstName }}
            {{ touch.createdByLastName
            }}<span> added this {{ touch.touchTypeName }}</span>
          </h4>

          <h4 class="meeting" *ngIf="touch.touchTypeName == 'Meeting'">
            <mat-icon>recent_actors</mat-icon> {{ touch.createdByFirstName }}
            {{ touch.createdByLastName
            }}<span> added this {{ touch.touchTypeName }}</span>
          </h4>

          <h4 class="others" *ngIf="touch.touchTypeName == 'Other'">
            <mat-icon>add_to_photos</mat-icon> {{ touch.createdByFirstName }}
            {{ touch.createdByLastName
            }}<span> added this {{ touch.touchTypeName }}</span>
          </h4>

          <h4 class="others" *ngIf="touch.touchTypeName == 'Log'">
            <mat-icon>text_snippet</mat-icon> {{ touch.createdByFirstName }}
            {{ touch.createdByLastName
            }}<span> added this {{ touch.touchTypeName }}</span>
          </h4>

          <h4
            *ngIf="
              touch.touchTypeName != 'Note' &&
              touch.touchTypeName != 'Phone Call' &&
              touch.touchTypeName != 'Email' &&
              touch.touchTypeName != 'Meeting' &&
              touch.touchTypeName != 'Other' &&
              touch.touchTypeName != 'Log'">
            <mat-icon>touch_app</mat-icon> {{ touch.createdByFirstName }}
            {{ touch.createdByLastName
            }}<span> added this {{ touch.touchTypeName }}</span>
          </h4>

          <p class="completion">
            {{ touch.touchStatusName }} On:
            {{ touch.touchDate+'Z' | date: "MM/dd/yyyy" }}
            {{ touch.touchTime | date: "h:mm a" }}
          </p>
         
          <p>
            {{ touch.touchNote }}
          </p>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

<app-addtouches
  *ngIf="isAddTouchVisible"
  [modulename]="modulename"
  [entityID]="folderetails.formFolderID">
</app-addtouches>

<associate-contact-role-form
  [typeId]="typeId"
  [formFolderID]="folderetails.formFolderID"
  *ngIf="isAddContactRoleShow">
</associate-contact-role-form>


<ng-template #shareAdd>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>group_add</mat-icon></span>
    Share with Contact and Role

    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <app-contactlist></app-contactlist>
    <ul class="selectedlist">
      <li *ngFor="let user of peoples">
        <div class="userndetail">
          <div class="pic">
            <img src="../../../assets/images/avatars/{{ user.img }}" alt="" />
          </div>
          <div class="detail">
            <h4>{{ user.name }}</h4>
            <p>{{ user.email }}</p>
          </div>
        </div>
        <div class="option">
          <button
            mat-flat-button
            [matMenuTriggerFor]="menu"
            aria-label="Permission">
            <mat-icon>visibility</mat-icon>Viewer
          </button>
          <mat-menu #menu="matMenu" xPosition="before">
            <button disabled mat-menu-item>
              <mat-icon>visibility</mat-icon>
              <span>Viewer</span>
            </button>
            <button mat-menu-item>
              <mat-icon>text_fields</mat-icon>
              <span>Editor</span>
            </button>
            <button mat-menu-item>
              <mat-icon>delete</mat-icon>
              <span>Remove</span>
            </button>
          </mat-menu>
        </div>
      </li>
    </ul>
  </mat-dialog-content>
  <mat-dialog-actions >
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary">Done</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #access>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>group_add</mat-icon></span>
    File Access

    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <mat-card class="fileAccess">
      <table class="mat-table">
        <tr class="mat-header-row">
          <th class="mat-header-cell">Role</th>
          <th class="mat-header-cell w100">Read</th>
          <th class="mat-header-cell w100">Write</th>
          <th class="mat-header-cell w100">Delete</th>
        </tr>
        <tr class="mat-row">
          <td class="mat-cell">Admissions</td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
        </tr>
        <tr class="mat-row">
          <td class="mat-cell">Doctor</td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
        </tr>
        <tr class="mat-row">
          <td class="mat-cell">Admin</td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
        </tr>
        <tr class="mat-row">
          <td class="mat-cell">Employer</td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
        </tr>
      </table>
    </mat-card>
  </mat-dialog-content>
  <mat-dialog-actions >
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary">Done</button>
  </mat-dialog-actions>
</ng-template>
